import ProblemDetailsException from "@rmp/core/exceptions/problemDetailsException";

export default class InvalidBusinessOperationException extends ProblemDetailsException {
}
